import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { BulkUploadIconsResponse, NamedResponse } from 'src/app/shared/models/shared.models';
import { ProductDepartmentsModel } from '../models/product-departments.model';

@Injectable({
  providedIn: 'root',
})
export class ProductDepartmentsService {
  private companyApiUrl = environment.companyApiUrl;
  constructor(private http: HttpClient) {}

  getAll(
    companyId: number,
    status?: number,
    pageNumber?: number,
    pageSize?: number,
    searchTerm?: string,
    clientSidePagination?: boolean,
  ) {
    let url = `${this.companyApiUrl}/ProductDepartments`;
    const params: string[] = [];

    if (companyId !== undefined) {
      params.push(`companyId=${companyId}`);
    }
    if (status !== undefined) {
      params.push(`Status=${status}`);
    }
    if (pageNumber !== undefined) {
      params.push(`PageNumber=${pageNumber}`);
    }
    if (pageSize !== undefined) {
      params.push(`PageSize=${pageSize}`);
    }
    if (searchTerm !== undefined && searchTerm.trim().length > 0) {
      params.push(`SearchTerm=${encodeURIComponent(searchTerm.trim())}`);
    }
    if (clientSidePagination !== undefined) {
      params.push(`ClientSidePagination=${clientSidePagination}`);
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get<ProductDepartmentsModel[]>(url);
  }

  getDepartmentsWithClientSidePagination(
    companyId: number,
    status?: number,
    clientSidePagination?: boolean,
  ) {
    let url = `${this.companyApiUrl}/ProductDepartments`;
    const params: string[] = [];

    if (companyId !== undefined) {
      params.push(`companyId=${companyId}`);
    }
    if (status !== undefined) {
      params.push(`Status=${status}`);
    }
    if (clientSidePagination !== undefined) {
      params.push(`ClientSidePagination=${clientSidePagination}`);
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get<ProductDepartmentsModel[]>(url);
  }

  add(user: any) {
    const url = `${this.companyApiUrl}/ProductDepartments`;
    return this.http.post(url, user);
  }
  importDepartmentsList(departmentsList: ProductDepartmentsModel[]) {
    const url = `${this.companyApiUrl}/ProductDepartments/Bulk`;
    return this.http.post(url, departmentsList);
  }

  updateById(user: any, id: number) {
    const url = `${this.companyApiUrl}/ProductDepartments/${id}`;
    return this.http.put(url, user);
  }

  getById(id: number) {
    const url = `${this.companyApiUrl}/ProductDepartments/${id}`;
    return this.http.get(url);
  }

  deleteById(id: number) {
    const url = `${this.companyApiUrl}/ProductDepartments/${id}`;
    return this.http.delete(url);
  }
  UploadProductDepartmentIcon(productDepartmentId: number, companyId: number, file: any) {
    const url = `${this.companyApiUrl}/ProductDepartments/${productDepartmentId}/UploadProductDepartmentIcon?companyId=${companyId}`;
    return this.http.post(url, file);
  }
  getDepartmentsLite(companyId?: number, searchTerm?: string) {
    let url = `${this.companyApiUrl}/ProductDepartments/Lite`;
    const params: string[] = [];

    if (companyId !== undefined) {
      params.push(`CompanyId=${companyId}`);
    }
    if (searchTerm !== undefined) {
      params.push(`SearchTerm=${searchTerm}`);
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get<NamedResponse[]>(url);
  }

  bulkUploadIcons(file: File, companyId: number, entityType: number) {
    const url = `${this.companyApiUrl}/BlobFiles/bulk-upload?companyId=${companyId}&entityType=${entityType}`;
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<BulkUploadIconsResponse>(url, formData);
  }
  changeStatus(id: number, status: number) {
    const url = `${this.companyApiUrl}/ProductDepartments/${id}/ChangeStatus`;
    return this.http.put(url, { status: status });
  }
}
